<template>
  <b-container fluid class="top-padding bottom-padding no-horiz-padding">

    <div>
        <h2>Documents on Weaving, Textiles, Lace, and Related Topics</h2>
        <p>
            This is an extensive digital archive of weaving, lace, and textile material created by Ralph Griswold. We are pleased and honored to be able to provide this wonderful collection to the world's community of weavers, lacemakers, and other textile artists!
        </p>
    </div>

    <b-button-group class=' bottom-padding'>
        <b-dropdown variant='primary' right text="Explore Documents">
            <b-dropdown-item to='/document-search/keyword'>Search by Keyword</b-dropdown-item>
            <b-dropdown-item to='/document-search/author'>List by Author</b-dropdown-item>
            <b-dropdown-item to='/document-search/publication'>List by Publication</b-dropdown-item>
            <b-dropdown-item to='/document-search/topic'>List by Topic</b-dropdown-item>
            <b-dropdown-item to='/document-search/language'>List by Language</b-dropdown-item>
        </b-dropdown>
    </b-button-group>

    <share-button/>

    <div class="row top-padding">
        <div class="col-md-12">
            <a href='/'>
                <img :src='this.getSiteImageUrl("Swift.png")' />
            </a>
        </div>
    </div>

    <helpUsButton/>
    <mailChimpSignup/>
  </b-container>

</template>

<script>
import mailChimpSignup from './MailChimpSignup.vue'
import helpUsButton from './HelpUsButton.vue'
import mediaService from '../mixins/mediaService.js'
import shareButton from './ShareButton.vue'
export default {
    mixins: [mediaService],
    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup,
        shareButton: shareButton
    },
    created() {
        this.$store.commit('setPageTitle', 'Textile Documents Archive')
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Documents.vue